module.exports = __webpack_public_path__ + "static/media/10.d4d2b3ea.svg";